// client/src/pages/MyPromptsPage.js
// Rebuilt Jun 2026 — stripped nav: Visibility · Citations · Sources · Prompt Entities
// Removed: Overview, Competitors, Manual Audit, sub-nav, tooltip

import React, { useState } from 'react';
import SidebarLayout from '../components/SidebarLayout';
import VisibilityOverview from '../components/VisibilityOverview';
import ContentGraphDashboard from '../components/ContentGraphDashboard';
import CitationsDashboard from '../components/CitationsDashboard';
import SourceAnalysisDashboard from '../components/SourceAnalysisDashboard';

if (typeof document !== 'undefined') {
  if (!document.querySelector('link[href*="Work+Sans"]')) {
    const fl = document.createElement('link');
    fl.href = 'https://fonts.googleapis.com/css2?family=Work+Sans:wght@300;400;500;600;700;800&display=swap';
    fl.rel = 'stylesheet';
    document.head.appendChild(fl);
  }
}

const colors = {
  primary: '#39393a',
  secondary: '#048ba8',
  tertiary: '#e9c46a',
  accent: '#f4a261',
  grey: '#e76f51',
  green: '#01796f'
};

const TABS = [
  { id: 'visibility',     label: 'VISIBILITY' },
  { id: 'citations',      label: 'CITATIONS' },
  { id: 'sources',        label: 'SOURCES' },
  { id: 'prompt-entities', label: 'PROMPT ENTITIES' },
];

const MyPromptsPage = ({ campaign, campaigns, apiBaseUrl }) => {
  const [activeTab, setActiveTab] = useState('visibility');

  return (
    <SidebarLayout currentCampaign={campaign} campaigns={campaigns} apiBaseUrl={apiBaseUrl}>
      <div style={{ padding: '24px', fontFamily: "'Work Sans', sans-serif" }}>

        {/* Tab nav */}
        <div style={{ backgroundColor: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)', border: '1px solid #e5e7eb', marginBottom: '24px' }}>
          <nav style={{ display: 'flex', gap: '32px', padding: '0 24px', borderBottom: '1px solid #e5e7eb' }}>
            {TABS.map(tab => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  style={{
                    padding: '16px 0',
                    fontSize: '13px',
                    fontWeight: '600',
                    letterSpacing: '0.5px',
                    background: 'none',
                    border: 'none',
                    borderBottom: isActive ? `2px solid ${colors.primary}` : '2px solid transparent',
                    marginBottom: '-1px',
                    color: isActive ? '#111827' : '#6b7280',
                    cursor: 'pointer',
                    transition: 'all 0.2s'
                  }}
                  onMouseEnter={e => { if (!isActive) e.currentTarget.style.color = '#374151'; }}
                  onMouseLeave={e => { if (!isActive) e.currentTarget.style.color = '#6b7280'; }}
                >
                  {tab.label}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab content */}
        <div>
          {activeTab === 'visibility' && campaign && (
            <VisibilityOverview
              campaignId={campaign.id}
              apiBaseUrl={apiBaseUrl}
            />
          )}

          {activeTab === 'citations' && campaign && (
            <CitationsDashboard
              campaignId={campaign.id}
              userId={campaign.userId}
              urls={campaign.urls}
              apiBaseUrl={apiBaseUrl}
            />
          )}

          {activeTab === 'sources' && campaign && (
            <SourceAnalysisDashboard
              campaignId={campaign.id}
              apiBaseUrl={apiBaseUrl}
            />
          )}

          {activeTab === 'prompt-entities' && campaign && (
            <ContentGraphDashboard
              campaign={campaign}
              campaignId={campaign.id}
              urls={campaign.urls}
              apiBaseUrl={apiBaseUrl}
            />
          )}

          {!campaign && (
            <div style={{ backgroundColor: '#fef3c7', border: '1px solid #fde68a', borderRadius: '8px', padding: '16px' }}>
              <p style={{ color: '#78350f', margin: 0, fontSize: '14px' }}>Select a campaign from the sidebar to view prompt data.</p>
            </div>
          )}
        </div>
      </div>
    </SidebarLayout>
  );
};

export default MyPromptsPage;
